import React, { Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './style.css';

function Page(props) {
    const {
        goTo,
        currentItem,
        lunes,
        martes,
        miercoles,
        jueves,
        viernes,
        sabado,
        domingo
    } = props;
     
    
    return (
        <Fragment>
            <CssBaseline />
            <div className="details-page" style={{display: 'flex',flexWrap: 'wrap', width:'100%'}}>
            </div>
            <div>
            {lunes && <div className="containerColumnaMob">
            {lunes && <div className="diaTituloM">Lunes</div>}
            {lunes.map(d => {
                return <Fragment>                 
                    <div className="horariob">{d.horaDesde}</div>
                    <div className="actividadb">{d.nombre} {d.descripcion}</div>
                    </Fragment>
            })}
            </div>}
            {martes && <div className="containerColumnaMob">
            {martes && <div className="diaTituloM">Martes</div>}
            {martes.map(d => {
                return <Fragment>                 
                    <div className="horariob">{d.horaDesde}</div>
                    <div className="actividadb">{d.nombre} {d.descripcion}</div>
                    </Fragment>
            })}
            
            </div>}

            {miercoles && <div className="containerColumnaMob">
            {miercoles && <div className="diaTituloM">Miercoles</div>}
            {miercoles.map(d => {
                return <Fragment>                 
                    <div className="horariob">{d.horaDesde}</div>
                    <div className="actividadb">{d.nombre} {d.descripcion}</div>
                    </Fragment>
            })}
            
            </div>}

            {jueves && <div className="containerColumnaMob">
            {jueves && <div className="diaTituloM">Jueves</div>}
            {jueves.map(d => {
                return <Fragment>                 
                    <div className="horariob">{d.horaDesde}</div>
                    <div className="actividadb">{d.nombre} {d.descripcion}</div>
                    </Fragment>
            })}
            
            </div>}

            {viernes && <div className="containerColumnaMob">
            {viernes && <div className="diaTituloM">Viernes</div>}
            {viernes.map(d => {
                return <Fragment>                 
                    <div className="horariob">{d.horaDesde}</div>
                    <div className="actividadb">{d.nombre} {d.descripcion}</div>
                    </Fragment>
            })}
            
            </div>}

            {sabado && <div className="containerColumnaMob">
            {sabado && <div className="diaTituloM">Sabado</div>}
            {sabado.map(d => {
                return <Fragment>                 
                    <div className="horariob">{d.horaDesde}</div>
                    <div className="actividadb">{d.nombre} {d.descripcion}</div>
                    </Fragment>
            })}
            
            </div>}

            {/* {domingo && <div className="containerColumna">
            {domingo && <div className="diaTitulo">sabado</div>}
            {domingo.map(d => {
                return <Fragment>                 
                    <div className="horariob">{d.horaDesde}</div>
                    <div className="actividadb">{d.nombre} {d.descripcion}</div>
                    </Fragment>
            })}
            
            </div>} */}
            </div>
            <div style={{flexBasis: '100%'}}></div> 
        </Fragment>
    );
}

export default Page;